import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import ArchiveNav from "../components/Archive/ArchiveNav.js";
import ArchiveMix from "../components/Archive/ArchiveMix.js";
import ArchiveHeader from "../components/Archive/ArchiveHeader.js";
import Thumbnail from "../components/Archive/Thumbnail.js";
import Loading from "../components/global/Loading.js";
import MobileFilters from "../components/Archive/MobileFilters.js";
// import Asterisk from "../components/Archive/Asterisk.js";

const Archive = (props) => {
  const {
    isMobile,
    currentPage,
    setCurrentPage,
    drawerMix,
    setDrawerMix,
    drawerOpen,
    setDrawerOpen,
    mixesData,
    setMixesData,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (currentPage !== "archive") {
      setCurrentPage("archive");
    }
  },[]);

  const [activeFilter, setActiveFilter] = useState("mixNumber");
  const [filterOrder, setFilterOrder] = useState("desc");

  const [archiveView, setArchiveView] = useState("grid");

  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  useEffect(() => {
    let newOrder;
    if (activeFilter === "mixNumber") {
      filterOrder === "asc"
        ? (newOrder = [...mixesData].sort((a, b) => a.mixNumber - b.mixNumber))
        : (newOrder = [...mixesData].sort((a, b) => b.mixNumber - a.mixNumber));
    }

    if (activeFilter === "title") {
      filterOrder === "asc"
        ? (newOrder = [...mixesData].sort((a, b) =>
            a.artistName.localeCompare(b.artistName)
          ))
        : (newOrder = [...mixesData].sort((a, b) =>
            b.artistName.localeCompare(a.artistName)
          ));
    }

    if (activeFilter === "releaseDate") {
      newOrder = [...mixesData].sort((a, b) => {
        const dateA = a.releaseDate;
        const dateB = b.releaseDate;

        if (!dateA && !dateB) return 0;
        if (!dateA) return 1; 
        if (!dateB) return -1;

        return filterOrder === "asc"
          ? dateA.localeCompare(dateB)
          : dateB.localeCompare(dateA);
      });
    }

    if (activeFilter === "duration") {
      filterOrder === "asc"
        ? (newOrder = [...mixesData].sort((a, b) => a.duration - b.duration))
        : (newOrder = [...mixesData].sort((a, b) => b.duration - a.duration));
    }

    if (activeFilter === "plays") {
      filterOrder === "asc"
        ? (newOrder = [...mixesData].sort(
            (a, b) => a.playbackCount - b.playbackCount
          ))
        : (newOrder = [...mixesData].sort(
            (a, b) => b.playbackCount - a.playbackCount
          ));
    }

    if (activeFilter === "genre") {
      filterOrder === "asc"
        ? (newOrder = [...mixesData].sort((a, b) =>
            a.genre.localeCompare(b.genre)
          ))
        : (newOrder = [...mixesData].sort((a, b) =>
            b.genre.localeCompare(a.genre)
          ));
    }

    if (activeFilter === "favs") {
      filterOrder === "asc"
        ? (newOrder = [...mixesData].sort(
            (a, b) => a.likesCount - b.likesCount
          ))
        : (newOrder = [...mixesData].sort(
            (a, b) => b.likesCount - a.likesCount
          ));
    }

    setMixesData(newOrder);
  }, [activeFilter, filterOrder]);

  if (mixesData) {
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        key={"archive-wrapper"}
      >
        {/* <Asterisk /> */}
        <ArchiveHeader
          {...{
            isMobile,
            mixesData,
            activeFilter,
            setActiveFilter,
            filterOrder,
            setFilterOrder,
            setMobileFiltersOpen,
          }}
        />
        {!isMobile ? (
          <ArchiveNav
            {...{
              archiveView,
              setArchiveView,
              setMobileFiltersOpen,
            }}
          />
        ) : (
          <MobileFilters
            {...{
              setActiveFilter,
              setFilterOrder,
              archiveView,
              setArchiveView,
              mobileFiltersOpen,
              setMobileFiltersOpen,
            }}
          />
        )}

        {archiveView === "list" ? (
          <section className="archive__container">
            {mixesData.map((mix, index) => {
              return (
                <ArchiveMix
                  mix={mix}
                  key={index}
                  {...{
                    isMobile,
                    index,
                    mixesData,
                    setMixesData,
                    drawerMix,
                    setDrawerMix,
                    drawerOpen,
                    setDrawerOpen,
                    activeFilter,
                  }}
                />
              );
            })}
          </section>
        ) : (
          <section key={"thumb-wrapper"} className="archive__grid-container">
            {mixesData.map((mix, index) => {
              return (
                <Thumbnail
                  mix={mix}
                  key={index}
                  {...{
                    setMixesData,
                    drawerMix,
                    setDrawerMix,
                    drawerOpen,
                    setDrawerOpen,
                  }}
                />
              );
            })}
          </section>
        )}
      </motion.main>
    );
  } else {
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        key={"archive-wrapper"}
        className="ra__fp-loading"
      >
        <Loading />
      </motion.main>
    );
  }
};

export default Archive;
